import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import chasLogo from '../../public/assets/images/chas-logo-row.svg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      marginLeft: theme.spacing(0.5),
      height: 20
    },
    toggleIcon: {
      color: 'var(--gray-text)'
    }
  })
);

type Props = {
  showSidebar: boolean;
  onToggle: () => void;
};
export const Header: React.FC<Props> = ({ showSidebar, onToggle }) => {
  const classes = useStyles();
  const { t } = useTranslation('signup');

  return (
    <Box display="flex" alignItems="center" height="100%" pl={0.5} pr={2}>
      <IconButton onClick={onToggle}>
        {!showSidebar && <MenuIcon className={classes.toggleIcon} />}
        {showSidebar && <MenuOpenIcon className={classes.toggleIcon} />}
      </IconButton>
      <img className={classes.logo} src={chasLogo} alt={t('helpPanel.chasLogoAlt', 'Veriforce CHAS')} />
    </Box>
  );
};
